import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Divider, Stack, Typography } from '@mui/material';
import { MAIN_ROUTE } from '../../constant/routes';
import { SectionDto } from '../../dto/SectionDto';
import Hist from '../../image/Gistology-Main.png';
import Bioc from '../../image/Biochemistry-Main.png';
import Phys from '../../image/Physiology-Main.png';
import { SECTION_NAME } from '../../constant/constants';

interface Props {
  dto?: SectionDto;
}

export const SectionItemDiv: FunctionComponent<Props> = ({ dto }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    localStorage.setItem(SECTION_NAME, dto?.name ?? '');
    navigate(`${MAIN_ROUTE}/${dto?.section}`);
  };

  const getImage = (route: string) => {
    if (route === 'histology') {
      return Hist;
    }
    if (route === 'biochemistry') {
      return Bioc;
    }
    if (route === 'physiology') {
      return Phys;
    }
    if (route === 'anatomy') {
      return Phys;
    }
    return '';
  };

  return (
    <div>
      <Card
        style={{
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px',
        }}
        onClick={handleClick}
      >
        <Stack alignItems="center" spacing={1}>
          <Typography
            sx={{
              bgcolor: '#FFFFFF',
              '&:hover': {
                bgcolor: '#9e9e9e',
              },
            }}
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '20px',
              color: '#000000',
            }}
            component="text"
          >
            {dto?.name}
          </Typography>
          <Divider style={{ width: '100%' }} />
          <img
            alt=""
            src={getImage(dto?.section ?? '')}
            width="60%"
            style={{ cursor: 'pointer' }}
          />
        </Stack>
      </Card>
    </div>
  );
};

SectionItemDiv.defaultProps = {
  dto: undefined,
};
